import React from 'react';

import './GameInterface.css';
import { useState } from 'react';
import { useEffect } from 'react';
import AnswerInterface from './AnswerInterface';

export default function GameInterface(props) {

	const {
			question,
			answer,
			qOpt,
			hasAnsweredCallback,
			userGameStatus,
			answerSet,
			checkWinCondition,
			isQOptAllDone
	 	} = props,
		[userAnswer, setUserAnswer] = useState({}),
		[maxPages, setMaxPages] = useState(0),
		[lastPage, setLastPage] = useState(0),
		[isQuestionAnswered, setIsQuestionAnswered] = useState(false),
		[revealAnswerCN, setRevealAnswerCN] = useState(''),
		[resetAnswer, setResetAnswer] = useState(false),
		[optionPaginationLoc, setOptionPaginationLoc] = useState(0),
		[optionPaginationStyle, setOptionPaginationStyle] = useState({left: optionPaginationLoc}),
		[optionPaginationCN, setOptionPaginationCN] = useState("options-pagination-container"),
		[prevPagStyle, setPrevPagStyle] = useState({opacity: optionPaginationLoc}),
		[nextPagStyle, setNextPagStyle] = useState({}),
		[addPagDelay, setAddPagDelay] = useState(false),
		[answerBtnData, setAnswerBtnData] = useState([]),
		isOnLastPage = () => optionPaginationLoc === lastPage,
		updateNextPagStyle = () => setNextPagStyle({opacity: (isOnLastPage() && !isQOptAllDone) ? .4 : 1}),
		updateAnswerData = ans => {
			setAnswerBtnData(answerBtnData.map(item=>{

				const show = item.show && ans!==item.label;

				return {
					label:item.label, 
					show
				}
			}));
		},
		handleUserAnswerCallback = (ans, hasAnsweredCorrectly)=>{
			if (hasAnsweredCorrectly) {
				updateAnswerData(ans);
			}

			if (!isQOptAllDone) {
				handleAnsweredOption();
			}
		},
		handlePagination = num => {
			return evt => {
				const 
					oLoc = optionPaginationLoc+num;

				if (oLoc < 0) {
					setOptionPaginationLoc(0);
				} else if(oLoc > lastPage) {
					setOptionPaginationLoc(lastPage);
				} else {
					setOptionPaginationLoc(oLoc);
				}
			};
		},
		handleAnsweredOption = (()=>{ 
			return evt => {
				setAddPagDelay(true);
				handlePagination(1)(evt);
			}
		})(),
		handleNextOption = (()=>{ 
			return evt => {
				if (isQOptAllDone && isOnLastPage()) {
					checkWinCondition();
				}
				handlePagination(1)(evt);
			}
		})(),
		handlePrevOption = handlePagination(-1);

	useEffect(()=>{
		setMaxPages(qOpt.length);
		setLastPage(qOpt.length-1);
	}, [qOpt.length])

	useEffect(()=>{
		if (isQuestionAnswered) {
			hasAnsweredCallback(userAnswer);
			window.setTimeout(()=>{setResetAnswer(true)}, 1000);
		}
	}, [isQuestionAnswered]);

	useEffect(()=>{
		if (userGameStatus.isCorrect === false) {
			setRevealAnswerCN('show');
		}
	}, [userGameStatus.isCorrect]);

	useEffect(()=>{
		const	
			prevOpacity = optionPaginationLoc,
			left = (-100 * optionPaginationLoc) + '%',
			transitionDelay = addPagDelay ? '1s' : '';

		setOptionPaginationStyle({left, transitionDelay});
		setPrevPagStyle({opacity: prevOpacity});
		updateNextPagStyle();
		setAddPagDelay(false);

		if (isQOptAllDone && isOnLastPage()) {
			checkWinCondition();
		}

	}, [optionPaginationLoc, isQOptAllDone, lastPage])

	useEffect(()=>{
		setAnswerBtnData((answerSet && answerSet.map(item=>({label:item,show:true}))) || []);
	},[answerSet]);

	
	useEffect(()=>{
		if (resetAnswer) {
			hasAnsweredCallback(userAnswer, true);
			setIsQuestionAnswered(false);
			setResetAnswer(false);
			setRevealAnswerCN('');
		}

	}, [resetAnswer]);
	return (
		<div className='game-interface'>
			<div className='inner-container'>
				<div className='question'>
					<div>
						{question}
					</div>
				</div>
				<div className='options-container'>
					<div className={optionPaginationCN} style={optionPaginationStyle}>
						{qOpt && qOpt.map((item, i)=>
							<div className={'option option-'+i + (item.isDone?' done' + (item.isCorrect?' correct':' incorrect'):'')} key={'option-'+i}>
								<div className='label'>
									{item.label}
								</div>
								<AnswerInterface
									{...props}
									answerSet={answerBtnData}
									hasAnsweredCallback={handleUserAnswerCallback}
									answer={item.answer}
									resetAnswer={resetAnswer}
									optionIndex={i}
								/>	
							</div>
						)}
					</div>
				</div>
				<div className='option-pagination'>
					<a onClick={handlePrevOption} className="prev" style={prevPagStyle}>Prev</a>
					<a onClick={handleNextOption} className="next" style={nextPagStyle}>{isOnLastPage()?'Continue':'Next'}</a>
				</div>
				<div className={'revealed-answer-container ' + revealAnswerCN}>
					<div className="revealed-answer">
						Correct Answer: <span>{answer}</span>
					</div>
				</div>
			</div>
		</div>
	);
}